import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daij8njp14a1h3mr756g";

type Status = "idle" | "loading" | "success" | "error";

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      if (typeof value === "string" && value.length > 0) {
        payload.append(key, value);
      }
    });

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，新档案上线时会第一时间通知你。");
      form.reset();
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");
      const ok = response.ok && parsed?.code === "OK" && !isSpam;

      if (ok) {
        setStatus("success");
        setMessage("订阅成功，新档案上线时会第一时间通知你。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后重试，或直接发送邮件联系我们。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，暂时无法提交，请稍后重试。");
    }
  };

  return (
    <form
      id="newsletter-subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col sm:flex-row gap-2.5">
        <label className="flex-1">
          <span className="sr-only">邮箱地址</span>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="留下邮箱，接收新档案提醒"
            className="w-full px-4 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          />
        </label>
        <button
          type="submit"
          disabled={status === "loading"}
          className="px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {status === "loading" ? "提交中…" : "订阅更新"}
        </button>
      </div>

      <div className="field-verify-wrap" aria-hidden="true">
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          readOnly
          aria-hidden="true"
        />
      </div>

      {message && (
        <p
          role="status"
          className={`mt-3 text-xs ${
            status === "success" ? "text-primary-600" : "text-primary-700"
          }`}
        >
          {message}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-500">
        我们每周整理 2 到 3 篇新档案。只发更新，不发广告，随时可以退订。
      </p>
    </form>
  );
}